import React, { Component } from 'react';
import styled from 'styled-components';
import { observer, inject } from 'mobx-react';
import { computed, observable } from 'mobx';
import { NavLink } from 'react-router-dom';
import {
  // SwitchHorizontalIcon,
  // ScaleIcon,
  // DatabaseIcon,
  UserCircleIcon,
} from '@heroicons/react/outline';

import { IconDashboard } from './Icons';

import { useLocation } from 'react-router-dom';
import Body from './Components/Body';
import { withRouter } from 'react-router-dom';

// import imageMap from './images';
import packageJson from '../package.json';
import { RingLoader } from 'react-spinners';

function HeaderExpand(props) {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return <SuperHeader active={isHomePage}>{props.children}</SuperHeader>;
}

function base64ToDataURL(base64String) {
  return `data:image/png;base64,${base64String}`;
}

@inject('store')
@observer
class SidebarCompontent extends Component {
  state = {
    isLoading: true,
    isFlipped: false,
    showProfileDropdown: false,
  };

  constructor(props) {
    super(props);
    if (this.props.location.pathname === '/signup') {
      this.props.history.push('/');
    }
    if (this.props.location.pathname === '/login') {
      this.props.history.push('/');
    }
  }

  handleLogoClick = e => {
    e.preventDefault();
    this.setState(prevState => ({ isFlipped: !prevState.isFlipped }));

    // Auto flip back after 5 seconds if flipped to second image
    if (!this.state.isFlipped) {
      this.autoFlipTimer = setTimeout(() => {
        this.setState({ isFlipped: false });
      }, 5000);
    } else {
      // Clear the timer if we're flipping back manually
      if (this.autoFlipTimer) {
        clearTimeout(this.autoFlipTimer);
        this.autoFlipTimer = null;
      }
    }
  };

  componentWillUnmount() {
    document.removeEventListener('keydown', this.shortcutHandler);
    // Clear the auto-flip timer if component unmounts
    if (this.autoFlipTimer) {
      clearTimeout(this.autoFlipTimer);
    }
  }
  componentDidMount() {
    document.addEventListener('keydown', this.shortcutHandler);
    document.addEventListener('mousedown', this.handleClickOutside);
    this.checkOrganizationDetails();
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.shortcutHandler);
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  // Reference to the profile dropdown
  profileDropdownRef = React.createRef();

  // Handle clicks outside the dropdown
  handleClickOutside = event => {
    if (
      this.profileDropdownRef.current &&
      !this.profileDropdownRef.current.contains(event.target) &&
      this.state.showProfileDropdown
    ) {
      this.setState({ showProfileDropdown: false });
    }
  };

  renderLogo() {
    const { organizationDetails } = this.props.store;
    if (!organizationDetails) return null;

    const { OrganizationName, OrganizationLogo } = organizationDetails;
    const { isFlipped } = this.state;

    let frontContent;

    // Determine the front content
    if (!OrganizationLogo) {
      // Return a styled default icon or text as fallback
      frontContent = (
        <div className="text-3xl font-bold w-14 h-14 rounded-md flex items-center justify-center shadow-sm">
          {OrganizationName?.charAt(0) || 'V'}
        </div>
      );
    } else if (OrganizationLogo.type === 'icon' && OrganizationLogo.icon) {
      // Handle icon type logo
      const Icon = OrganizationLogo.icon;
      frontContent = (
        <div className="rounded-md shadow-sm p-3">
          <Icon size={90} />
        </div>
      );
    } else if (typeof OrganizationLogo === 'string') {
      // Handle base64 string logo
      try {
        const logoDataURL = `data:image/png;base64,${OrganizationLogo}`;
        frontContent = (
          <Logo
            src={logoDataURL}
            alt={OrganizationName || 'Organization'}
            style={{ objectFit: 'contain' }}
          />
        );
      } catch (error) {
        console.error('Error rendering logo:', error);
        frontContent = (
          <div className="text-3xl font-bold w-14 h-14 rounded-md flex items-center justify-center shadow-sm">
            {OrganizationName?.charAt(0) || 'V'}
          </div>
        );
      }
    } else {
      // Fallback for any other case
      frontContent = (
        <div className="text-3xl font-bold w-14 h-14 rounded-md flex items-center justify-center shadow-sm">
          {OrganizationName?.charAt(0) || 'V'}
        </div>
      );
    }

    return (
      <FlipCardContainer onClick={this.handleLogoClick} isFlipped={isFlipped}>
        <FlipCardInner isFlipped={isFlipped}>
          <FlipCardFront>{frontContent}</FlipCardFront>
          <FlipCardBack>
            <Logo
              src="/header_14.jpg"
              alt="Virtus Auto"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                borderRadius: '10px',
              }}
            />
          </FlipCardBack>
        </FlipCardInner>
      </FlipCardContainer>
    );
  }

  checkOrganizationDetails = () => {
    const checkInterval = setInterval(() => {
      // If organizationDetails is loaded or user has requiresSubscriptionSetup flag
      if (
        this.props.store.organizationDetails ||
        this.props.store.requiresSubscriptionSetup
      ) {
        clearInterval(checkInterval);
        this.setState({ isLoading: false });
      }
    }, 100); // Check every 100ms

    // Set a timeout to prevent infinite loading
    setTimeout(() => {
      clearInterval(checkInterval);
      if (this.state.isLoading) {
        this.setState({ isLoading: false });
        console.error('Timeout while waiting for organizationDetails');
      }
    }, 10000); // 10 seconds timeout
  };

  shortcutHandler = e => {
    if (e.keyCode === 75 && e.ctrlKey) {
      e.preventDefault();
      // select all text in input with id q
      document.getElementById('q').focus();
      document.getElementById('q').select();
    }
  };

  onKeyUp = e => {
    if (this.props.location.pathname !== '/search') {
      this.props.history.push('/search');
    }
    if (e.keyCode === 8) {
      if (this.props.store.toolsKeyword === '') {
        this.props.history.push('/');
      }
    }
  };

  @computed get fromColor() {
    if (this.props.store.profile.credits <= 0) {
      return 'bg-red-200 text-red-600';
    }
    if (this.props.store.profile.status === 'trialing') {
      return '';
    }
    if (this.props.store.profile.status === 'active') {
      return '';
    }
    if (this.props.store.profile.status === 'incomplete') {
      return '';
    }
    return 'bg-red-200 text-red-600';
  }

  render() {
    const { organizationDetails, requiresSubscriptionSetup } = this.props.store;
    const { isLoading } = this.state;

    // If loading is in progress and user is not being redirected to subscription setup
    if (isLoading && !requiresSubscriptionSetup) {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            background: 'white',
          }}
        >
          <RingLoader color="#000000" size="120px" />
        </div>
      );
    }

    // If we're being redirected to subscription setup, don't require organizationDetails
    if (requiresSubscriptionSetup) {
      // Use safe default values for subscription flow
      const defaultOrgDetails = {
        OrganizationName: 'Organization',
        Title1: 'Virtus',
        Title2: '',
        Description: 'Platform',
      };

      // Temporarily use default values if not loaded yet
      if (!organizationDetails) {
        this.props.store.organizationDetails = defaultOrgDetails;
      }
    } else if (!organizationDetails) {
      // If we still don't have organization details and we're not in subscription flow
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            background: 'white',
          }}
        >
          <RingLoader color="#000000" size="120px" />
        </div>
      );
    }

    // Safely destructure with default values for null fields
    const {
      OrganizationName = 'Organization',
      Title1 = 'Virtus',
      Title2 = '',
      Description = 'Platform',
    } = organizationDetails || {};

    return (
      <>
        <Textarea
          readOnly
          name="copy-textarea"
          id="copy-textarea"
          value={this.props.store.copyToClipboardText}
        />
        <HeaderExpand>
          <Body className="px-4 py-2 md:px-28 md:py-3 lg:py-4 flex items-center justify-between flex-1">
            <div className="flex items-center">
              <div className="mr-10 flex justify-center mb-2">
                {this.renderLogo()}
              </div>
              <div>
                <div className="text-3xl relative font-medium text-transparent bg-clip-text bg-gradient-to-r from-gray-700 to-gray-600 inline-block">
                  {Title1 || 'Virtus'}
                  <span className="font-normal ">{Title2 || ''}</span>
                  <div className="absolute top-0 ml-3 left-full bg-gradient-to-r from-yellow-200 to-yellow-200 text-black text-xs px-2 py-0.5 hidden md:inline-block rounded-md font-normal ">
                    v{packageJson.version}
                  </div>
                </div>
                <div className="hidden md:block text-lg text-transparent bg-clip-text bg-gradient-to-r from-gray-700 to-gray-500 inline-block">
                  {Description || 'Platform'}
                </div>
                {/* <div className="flex">
                  <div className={`items-center flex inline-flex ${this.props.store.profile.credits ? " bg-gray-100 text-gray-500" : " bg-red-100 text-red-500"} text-sm rounded-md px-3 py-1 font-medium my-2 mr-2`}>
                    <DatabaseIcon className="w-4 h-4 mr-2" />{this.props.store.profile.credits}&nbsp;<span className="hidden lg:block">{orgDetails.CreditsRemain}</span>
                  </div>
                </div> */}
              </div>
            </div>
            <div className="hidden md:block">
              {/* Additional header content could go here */}
            </div>
          </Body>
        </HeaderExpand>
        <div className="border-b border-gray-200 bg-white">
          <div className="container flex mx-auto px-4 md:px-28 flex select-none items-center">
            <NavLink
              to="/"
              exact
              tabIndex={-1}
              onClick={() => (this.props.store.toolsKeyword = '')}
              activeClassName="text-gray-800 border-b-2 border-gray-800"
              className="text-sm flex py-1 px-4 cursor-pointer hover:text-gray-800 font-medium transition items-center"
            >
              <IconDashboard className="w-5 h-5 lg:mr-2 transition" />
              <div className="hidden lg:block">{'Módulos'}</div>
            </NavLink>

            <div className="relative text-gray-400 focus-within:text-green-500 flex flex-1 ">
              {/* <label htmlFor="q" className="absolute inset-y-0 left-0 top-0 bottom-0 hidden md:flex items-center lg:pl-2 ">
                <div type="submit" className="p-2 focus:outline-none focus:shadow-outline ">
                <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" className="w-6 h-6 transition"><path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path></svg>
                </div>
              </label> */}
              {/* <Input 
                  type="search" 
                  tabIndex={-1}
                  id="q"
                  name="q" 
                  className="py-4 pl-4 md:pl-14 text-xl focus:outline-none focus:bg-white focus:text-gray-900 transition flex flex-1 w-full" placeholder="Search...  [Shortcut: Ctrl + K]" autoComplete="off" 
                  value={this.props.store.toolsKeyword} 
                  onChange={this.props.store.onChangeToolsKeyword} 
                  onKeyUp={this.onKeyUp}
                /> */}
            </div>
            <div className="relative" ref={this.profileDropdownRef}>
              <button
                onClick={() =>
                  this.setState(prevState => ({
                    showProfileDropdown: !prevState.showProfileDropdown,
                  }))
                }
                className="text-sm flex py-1 px-4 cursor-pointer hover:text-gray-800 font-medium transition items-center"
              >
                <UserCircleIcon className="w-5 h-5 lg:mr-2 transition" />
                <div className="hidden lg:flex items-center">
                  <span className="mr-1">
                    {this.props.store.profile.username || 'Usuario'}
                  </span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className={`h-4 w-4 transition-transform duration-200 ${this.state.showProfileDropdown ? 'transform rotate-180' : ''}`}
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>
              </button>

              {this.state.showProfileDropdown && (
                <div className="absolute right-0 mt-2 py-2 w-48 bg-white rounded-md shadow-lg z-50 border border-gray-200">
                  <NavLink
                    to="/my-profile"
                    exact
                    className="block px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                    onClick={() =>
                      this.setState({ showProfileDropdown: false })
                    }
                  >
                    <div className="flex items-center">
                      <UserCircleIcon className="w-5 h-5 mr-2" />
                      Mi perfil
                    </div>
                  </NavLink>
                  <button
                    onClick={() => {
                      this.setState({ showProfileDropdown: false });
                      this.props.store.handleLogout();
                    }}
                    className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                  >
                    <div className="flex items-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5 mr-2"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                        />
                      </svg>
                      Cerrar sesión
                    </div>
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
        {this.props.children}
      </>
    );
  }
}

const FlipCardContainer = styled.div`
  cursor: pointer;
  background-color: transparent;
  width: 380px;
  height: 200px; /* Smaller to avoid overlap with nav bar */
  perspective: 1000px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px; /* Add space at bottom to prevent overlap */
`;

const FlipCardInner = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  transition: transform 0.6s;
  transform-style: preserve-3d;
  transform: ${props =>
    props.isFlipped ? 'rotateY(180deg)' : 'rotateY(0deg)'};
`;

const FlipCardFront = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  background-color: transparent;
`;

const FlipCardBack = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  transform: rotateY(180deg);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  background-color: transparent;
`;

const Logo = styled.img`
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
`;

const Input = styled.input``;

const Textarea = styled.textarea`
  position: fixed;
  right: -9990px;
  top: -9990px;
`;

// transition:ease-in-out 0.5s margin-top;
// 	transition-delay:0.05s;

const SuperHeader = styled.div`
  min-height: ${props => (props.active ? '130px' : '0')};
  max-height: ${props => (props.active ? '230px' : '0')};
  height: auto;
  padding: ${props => (props.active ? '12px 0' : '0')};
  background: white;
  overflow: hidden;
  transition: all 0.5s ease-in-out;
  background-image: url(${require('./grid2_transparent.png').default});
  background-size: auto 80%;
  background-position: 0px 0px;
  background-repeat: no-repeat;
  position: relative;
`;

export default withRouter(SidebarCompontent);
